import { Cell, Grid, Heading } from 'bold-ui'
import { TelefoneField, TextField } from 'components/form'
import { NacionalidadeEnum } from 'graphql/types.generated'
import { MetaPath } from 'util/metaPath'

import { ContatosFormModel } from '../types/model-cidadao'

interface ContatosFormSectionProps {
  meta: MetaPath<ContatosFormModel>
  nacionalidade: NacionalidadeEnum
  isCidadaoAldeado?: boolean
}

export const ContatosFormSection = ({ meta, nacionalidade, isCidadaoAldeado = false }: ContatosFormSectionProps) => {
  const isTelefoneCelularRequired = nacionalidade !== NacionalidadeEnum.ESTRANGEIRA && !isCidadaoAldeado

  return (
    <Grid>
      <Cell size={12}>
        <Heading level={2}>Contatos</Heading>
      </Cell>
      <Cell size={2}>
        <TelefoneField name={meta.telefoneCelular} label='Telefone celular' required={isTelefoneCelularRequired} />
      </Cell>
      <Cell size={2}>
        <TelefoneField name={meta.telefoneResidencial} label='Telefone residencial' />
      </Cell>
      <Cell size={2}>
        <TelefoneField name={meta.telefoneContato} label='Telefone de contato' />
      </Cell>
      <Cell size={6} />
      <Cell size={6}>
        <TextField name={meta.email} label='E-mail' lowercase minLength={6} maxLength={100} />
      </Cell>
      <Cell size={6} />
    </Grid>
  )
}
